// extracted by mini-css-extract-plugin
export default {"progressContainer":"ActivateDeactivateButton_progressContainer__97juO","progress":"ActivateDeactivateButton_progress__Gx73l"};